<div class="usan-form-item absence-of-conflict-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ hasAbsenceOfConflictDocument ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column">
      <span class="required-star" *ngIf="isDocumentRequired">*</span>
      <span class="usan-form-item absence-of-conflict-item absence-of-conflict-text">
        Verification of the Absence of conflicts
        <ul>
          <li>Trademark search results (WIPO database, Corsearch)</li>
          <li>Analysis of suggested names using the FDA's POCA online tool</li>
          <li>Google search</li>
        </ul>
      </span>
    </div>
  </div>
  <div class="input-error" *ngIf="showRequiredError">
    This is a required document.
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-absence-of-conflict form-btn form-btn-style form-btn-text"
      (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload absence of conflict documentation
    </button>
  </div>
  <ng-container *ngIf="hasAbsenceOfConflictDocument">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>
